import { render, staticRenderFns } from "./AddFixedAssetToRentalModal.yaml?vue&type=template&id=458d1a04&component"
import script from "./AddFixedAssetToRentalModal.yaml?vue&type=script&lang=ts&component"
export * from "./AddFixedAssetToRentalModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports